import ChairishABTest from 'chairisher/abtest';

/**
 * AB Test for determining if removing Afterpay will lead to an overall increase in sales.
 *
 * Note: All logic is implemented server side
 *
 * TODO: (CHAIR-17993) Delete file after AB test
 */
export default class RemoveAfterpayTest extends ChairishABTest {
    static getExperimentName() {
        return 'REMOVE_AFTERPAY_TEST_2';
    }
}
